export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    usedAffid: 'Used Affid',
    fillRate: 'Fill Rate',
    errPercent: 'Err %',
    emptyPercent: 'Empty %'
};



// WEBPACK FOOTER //
// ./src/scenes/BidderCtrHourly/config.js